/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicSearchServiceService {
  formData: any;
  dropDownValues: any = {};

  constructor() { }
  setFormData(formData) {
    this.formData = formData;
  }

  generateDynamicForm(type) {
    const searchArray = this.formData[type];
    return searchArray;
  }

  generateIndividualField(type) {
    this.dropDownValues = {};
    const searchField = this.formData[type]['individualField'];
    return searchField;
  }

  generateDynamicFormDropdown(searchArray) {
    this.dropDownValues = {};
    for (const field of searchArray) {
      if (field['type'] === 'select' && (this.dropDownValues[field['name']] === null ||
        this.dropDownValues[field['name']] === undefined)) {
        this.dropDownValues[field['name']] = field['values'];
      }
    }
    return this.dropDownValues;
  }

}
